import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { loadStripe } from '@stripe/stripe-js/pure'
import { Elements } from '@stripe/react-stripe-js'
import StripeWidgets from './components/StripeWidgets'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import type { Stripe, StripeElementsOptionsMode } from '@stripe/stripe-js'
import { getStripeCredentials } from 'api/order'
import { STRIPE_ELEMENTS_APPEARANCE } from 'lib/payment/stripeUtils'
import { connect } from 'react-redux'
import styled from 'styled-components'

const RelativeContainer = styled.div`
  position: relative;
`

interface State {
  stripeConnect?: Stripe | null
  stripePlatform?: Stripe | null
  chargeDescriptors?: any
}

interface Props extends MappedProps {
  regionCode: string
  currencyCode: string
  purpose: string
  purposeId: string
  onSuccess?: () => void
  onFailure?: () => void
}

type MappedProps = Pick<Props, 'regionCode' | 'currencyCode'>

export function StripeOffsessionCardUpdate(props: Props) {
  const intl = useIntl()
  const { currencyCode, regionCode, purposeId, purpose, onSuccess, onFailure } = props
  const [state, setState] = useState({} as State)
  useEffect(() => {
    getStripeCredentials(currencyCode).then(async data => {
      setState({
        stripePlatform: await loadStripe(data.stripe_publishable_key),
        stripeConnect: await loadStripe(data.stripe_publishable_key, {
          stripeAccount: data.stripe_account,
        }),
        chargeDescriptors: data.charge_descriptors,
      })
    })
  }, [currencyCode])

  const { stripeConnect, stripePlatform, chargeDescriptors } = state

  const StripePaymentElementOptions: StripeElementsOptionsMode = {
    mode: 'setup',
    paymentMethodCreation: 'manual',
    currency: currencyCode.toLowerCase(),
    paymentMethodTypes: ['card'],
    appearance: STRIPE_ELEMENTS_APPEARANCE,
  }

  const loadingText = intl.formatMessage({
    id: 'pybYOIIlZ5bXLedXatUf',
    defaultMessage: 'Loading...',
    description: 'Loading indicator text with ellipsis shown while content is being fetched',
  })

  return (
    <RelativeContainer>
      {stripeConnect &&
        <Elements stripe={stripeConnect} options={StripePaymentElementOptions}>
          <StripeWidgets
            currencyCode={currencyCode}
            regionCode={regionCode}
            chargeDescriptors={chargeDescriptors}
            stripe={stripeConnect}
            purpose={purpose}
            purposeId={purposeId}
            onSuccess={onSuccess}
            onFailure={onFailure}
          />
        </Elements>}
      <LoadingIndicator floating visible={!stripePlatform}>{loadingText}</LoadingIndicator>
    </RelativeContainer>
  )
}

function mapStateToProps(state: App.State): MappedProps {
  return {
    regionCode: state.geo.currentRegionCode,
    currencyCode: state.geo.currentCurrency,
  }
}

export default connect(mapStateToProps)(StripeOffsessionCardUpdate)
